import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const restriction = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getRestrictions () {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions`)
  },
  getRestriction (restrictionId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/` + restrictionId)
  },
  saveRestriction (restriction) {
    if(restriction.id){
      return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/${restriction.id}`, restriction)
    } else {
      return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions`, restriction)
    }
  },
  activateRestriction (restrictionId) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/${restrictionId}/activate`)
  },
  deactivateRestriction (restrictionId) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/${restrictionId}/deactivate`)
  },
  editRestriction (restriction) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/${restriction.id}`, restriction)
  },
  deleteRestriction (id) {
    return Axios.delete(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/restrictions/` + id)
  }
}

export default restriction
